import React, { Fragment } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Container } from "reactstrap";
import { Breadcrumbs, P } from "../../AbstractElements";
import { useLocationItem } from "../../hooks/useLocationItem";

const CpaiLocationPagePlaceholder = ({ title }) => {
  const [searchParams] = useSearchParams();
  const locationIdParam = searchParams.get("location_id");
  const { location, loading, error } = useLocationItem(locationIdParam);
  const listPath = `${process.env.PUBLIC_URL}/location-list`;

  const mainTitle = error
    ? title
    : loading
      ? "Загрузка…"
      : location
        ? `${location.name} — ${title}`
        : title;

  return (
    <Fragment>
      <Breadcrumbs
        mainTitle={mainTitle}
        title={mainTitle}
        parent={
          <Link to={listPath} className="text-decoration-none">
            Список локаций
          </Link>
        }
      />
      <Container fluid={true} className="product-wrapper">
        {loading && <P className="text-center w-100">Загрузка…</P>}
        {error && !loading && (
          <P className="text-center text-danger w-100">{error}</P>
        )}
        {!loading && !error && location ? (
          <P className="text-muted w-100 mb-0">Раздел в разработке.</P>
        ) : null}
      </Container>
    </Fragment>
  );
};

export default CpaiLocationPagePlaceholder;
